import { useTranslation } from 'react-i18next';
import camelCase from 'lodash/camelCase';
import {
  Typography,
  PLATFORM_THEME_COLORS,
  Form,
  TextInput,
  TextAreaInput,
  Button,
  ICONS,
  Icon,
  SelectInput,
} from '@thinknet-gmbh/platform-common-ui';

import { HighestTrainingDegreeEnum, SchoolOptionsEnum } from '@thinknet-gmbh/platform-common';

import { BooleanSelectInput } from 'src/pages/employee/components/boolean-select-input';

import {
  FieldsInfoWrapper,
  ComponentWrapper,
  DeleteContainer,
  FormListWrapper,
  EducationContainer,
  SkillsContainer,
  EducationColumnContainer,
} from '../questionnaire-form/questionnaire-form.styles';

const EducationsAndSkills = () => {
  const { t } = useTranslation(['common', 'employee', 'products']);

  return (
    <ComponentWrapper>
      <Typography weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
        {t('employee:educationsAndSkills.labels.headerTitle')}
      </Typography>

      <EducationContainer>
        <FieldsInfoWrapper>
          <EducationColumnContainer>
            <Form.Item
              className={'middle-width-item'}
              name={['educationAndSkills', 'schoolName']}
              label={t(`employee:educationsAndSkills.labels.schoolName`)}
            >
              <SelectInput
                placeholder={t('employee:educationsAndSkills.placeholders.schoolName')}
                dropdownMatchSelectWidth={false}
              >
                {Object.keys(SchoolOptionsEnum).map(name => {
                  return (
                    <SelectInput.Option value={name} key={name}>
                      {t(`employee:labels.schoolOptions.${camelCase(name.toLowerCase())}`)}
                    </SelectInput.Option>
                  );
                })}
              </SelectInput>
            </Form.Item>
            <Form.Item
              className={'middle-width-item'}
              name={['educationAndSkills', 'furtherName']}
              label={t(`employee:educationsAndSkills.labels.furtherName`)}
            >
              <TextInput maxLength={50} placeholder={t('employee:educationsAndSkills.placeholders.furtherName')} />
            </Form.Item>
            <Form.Item
              className={'middle-width-item'}
              name={['educationAndSkills', 'trainingName']}
              label={t(`employee:educationsAndSkills.labels.trainingName`)}
            >
              <TextInput maxLength={50} placeholder={t('employee:educationsAndSkills.placeholders.trainingName')} />
            </Form.Item>
            <Form.Item
              className={'middle-width-item'}
              name={['educationAndSkills', 'highestTrainingDegree']}
              label={t(`employee:educationsAndSkills.labels.highestTrainingDegree`)}
            >
              <SelectInput
                dropdownMatchSelectWidth={false}
                placeholder={t('employee:educationsAndSkills.placeholders.highestTrainingDegree')}
              >
                {Object.keys(HighestTrainingDegreeEnum).map(name => {
                  return (
                    <SelectInput.Option value={name} key={name}>
                      {t(`employee:labels.highestTrainingOptions.${camelCase(name.toLowerCase())}`)}
                    </SelectInput.Option>
                  );
                })}
              </SelectInput>
            </Form.Item>
          </EducationColumnContainer>
          <EducationColumnContainer>
            <Form.Item
              name={['educationAndSkills', 'universityName']}
              label={t(`employee:educationsAndSkills.labels.universityName`)}
            >
              <TextInput maxLength={50} placeholder={t('employee:educationsAndSkills.placeholders.universityName')} />
            </Form.Item>
            <Form.Item
              name={['educationAndSkills', 'driversLicenses']}
              label={t(`employee:educationsAndSkills.labels.driversLicenses`)}
            >
              <BooleanSelectInput t={t} />
            </Form.Item>
          </EducationColumnContainer>
        </FieldsInfoWrapper>
        <SkillsContainer>
          <Form.List name={['educationAndSkills', 'skills']} initialValue={undefined}>
            {(fields, { add, remove }) => (
              <FormListWrapper isIcon={fields.length > 1}>
                <Typography weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
                  {t('employee:educationsAndSkills.labels.skills')}
                </Typography>
                <div>
                  {fields.map((field, index) => (
                    <div key={`${field.key}-${index}-social`}>
                      <DeleteContainer isIcon={fields.length > 1}>
                        <Form.Item
                          name={[field.name, 'name']}
                          label={t('employee:educationsAndSkills.labels.skillsName')}
                        >
                          <TextInput
                            maxLength={50}
                            placeholder={t('employee:labels.startTyping')}
                          />
                        </Form.Item>
                        {fields.length > 1 && (
                          <Icon
                            icon={ICONS.trash}
                            rightMargin={false}
                            color={PLATFORM_THEME_COLORS.tone.red}
                            size={22}
                            onClick={() => remove(field.name)}
                          />
                        )}
                      </DeleteContainer>
                      <Form.Item
                        name={[field.name, 'description']}
                        label={t('common:labels.description')}
                      >
                        <TextAreaInput
                          showCount
                          maxLength={500}
                          placeholder={t(
                            'products:planList.createPlan.placeholders.writeDescription'
                          )}
                        />
                      </Form.Item>
                    </div>
                  ))}
                </div>
                <Button
                  type="text"
                  icon={ICONS.plus}
                  iconColor={PLATFORM_THEME_COLORS.primary.blue}
                  onClick={() => add()}
                >
                  {t('employee:educationsAndSkills.buttons.addNewSkill')}
                </Button>
              </FormListWrapper>
            )}
          </Form.List>
        </SkillsContainer>
      </EducationContainer>
    </ComponentWrapper>
  );
};

export default EducationsAndSkills;
